<template lang="html">
  <div id="exchange-loading">
    <a href="" @click.prevent="open" :color="btnColor" :type="btnType"  :icon="btnIcon">{{ btnText }} </a>
    <vs-popup :title="popupTitle" :active.sync="popupActivo" ref="popExchange" :class="['text-sentence']">
      <div class="px-4"> 
        <vs-row class="mb-2"> 
            <vs-col vs-w="6" class="font-semibold text-right"> {{$t('period')+' : '}} </vs-col>
            <vs-col vs-w="6">{{period.PeriodId}}</vs-col>
        </vs-row>
        <vs-row class="mb-2"> 
            <vs-col vs-w="6" class="font-semibold text-right"> {{ $t('week')+' : '}} </vs-col>
            <vs-col vs-w="6">{{period.Week}}</vs-col>
        </vs-row>
        <vs-row class="mb-2"> 
            <vs-col vs-w="6" class="font-semibold text-right"> {{ $t('year')+' : '}} </vs-col>
            <vs-col vs-w="6">{{period.Year}}</vs-col>
        </vs-row>
        <vs-row class="mb-2"> 
            <vs-col vs-w="6" class="font-semibold text-right"> {{ $t('from_date')+' : '}} </vs-col>
            <vs-col vs-w="6"> {{formatDate(period.BeginDate)}}</vs-col>
        </vs-row>
        <vs-row class="mb-2"> 
            <vs-col vs-w="6" class="font-semibold text-right"> {{ $t('to_date')+' : '}} </vs-col>
            <vs-col vs-w="6">{{' '+formatDate(period.EndDate)}}</vs-col>
        </vs-row>
        <vs-row class="my-2">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12"  class="font-semibold text-right text-primary"> {{ $t('exchange_rate')}} </vs-col>
        </vs-row>
        <vs-row class="mt-2">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <vs-input v-model="newExchangeRate" name="exchange" v-validate="{required:true,min_value:min,decimal:4}" autocomplete="off" />
            </vs-col>
            <vs-col vs-w="12">
              <span
                class="text-danger text-sm"
                v-show="errors.has('exchange')"
              >{{ errors.first('exchange') }}</span>
            </vs-col>
        </vs-row>
          <vs-row vs-align="center" vs-type="flex" vs-justify="center" class="mt-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" class="mt-2 px-2">
                <vs-button color="primary" type="filled" class="w-full" @click="submit" :disabled="!isFormValid">{{ $t('submit') }}</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" class="mt-2 px-2">
              <vs-button color="primary" type="border" class="w-full" @click="close">{{ $t('cancel') }}</vs-button>
            </vs-col>
        </vs-row>
      </div> 
    </vs-popup>
  </div>
</template>

<script>
export default {
  props: {
    btnColor: {
      type: String,
      default: 'primary',
    },
    btnType: {
      type: String,
      default: 'border',
    },
    btnIcon: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: 'button',
    },
    popupTitle: {
      type: String,
      default: 'title',
    },
    min: {
      type: Number,
      default: 0,
    },
    period: {
      type: Object,
      default: {
        PeriodId: '0',
        Week: '0',
        Month: '0',
        Year: '0',
        BeginDate: 'MM-DD-YYYY',
        EndDate: 'MM-DD-YYYY',
        ExchangeRate: '1.0000',
      },
    },
  },
  data() {
    return {
      popupActivo: false,
      newExchangeRate: '',
    }
  },
  computed:{
     isFormValid () {
      return !this.errors.any() && this.newExchangeRate !== ''
    },
  },
  methods: {
    open() {
      this.popupActivo = true
      this.newExchangeRate = ''
      this.$validator.reset()
    },
    close() {
      this.popupActivo = false
    },
    submit() {
      this.openLoading()
      this.$store.dispatch('invoice/updatePeriodExchangeRate',{period_id:this.period.PeriodId, newExchangeRate:this.newExchangeRate})
      .then(res => {
        this.$vs.notify({
          color: 'success',
          title: 'Action',
          text: 'Update Exchange Rate',
        })
        this.close()
        this.closeLoading()
      })
       .catch(res => {
         this.closeLoading()
        this.$vs.notify({
          color: 'danger',
          title: 'Attention',
          text: 'Error Update',
        })
        
      })
    },
    openLoading() {
      this.$vs.loading({
       container: '#exchange-loading',
       scale: 0.6
      })
    },
    closeLoading:function() {
      this.$vs.loading.close('#exchange-loading > .con-vs-loading')
    },
  },
}
</script>


<style>
/* @media (min-width: 576px) {
  .con-vs-popup .vs-popup {
    width: 60vw;
  }
} */

/* @media (min-width: 992px) {
  .con-vs-popup .vs-popup{
    width: 22vw;
  }
} */

.qb-class{
  width: 22vw;
}
</style>